import React from "react";
import { PressEvent } from "react-aria-components";
import { useHistory } from "react-router";
import { buildLink } from "common/routing";
import { Button } from "../../../Common/Buttons/Button";
import { DropdownMenu } from "../../../Inputs";
import MenuOption from "./MenuOption";

const BulkPropertyActionMenu = () => {
  const history = useHistory();

  const actions = [
    {
      label: "Create properties",
      onClick: () =>
        history.push({
          pathname: buildLink("dispatchBulkPropertyCreation"),
        }),
    },
    {
      label: "Create or update records",
      onClick: () =>
        history.push({
          pathname: buildLink("dispatchBulkSubmissionCreation"),
        }),
    },
    {
      label: "Upload documents",
      onClick: () =>
        history.push({
          pathname: buildLink("dispatchBulkDocumentUploadCreate"),
        }),
    },
    {
      label: "Geocode addresses",
      onClick: () =>
        history.push({
          pathname: buildLink("dispatchBulkGeocodeCsv"),
        }),
    },
    {
      label: "Bulk Document generation",
      onClick: () =>
        history.push({
          pathname: buildLink("dispatchBulkDocumentGeneration"),
        }),
    },
    {
      label: "Export property and parcel information",
      onClick: () =>
        history.push({
          pathname: buildLink("exportPropertyAndParcelInfo"),
        }),
    },
  ];

  const AddNewButton = ({ onPress }: { onPress: (_: PressEvent) => void }) => (
    <Button
      onPress={onPress}
      variant="outline"
      size="small"
      data-testid="bulk-actions-button"
      iconEnd="chevron-down"
      title="Actions"
    />
  );

  return (
    <MenuOption
      title="Bulk actions"
      helperText="Upload a CSV and dispatch a bulk operation using the CSV as input data."
      actionsDropdown={
        <DropdownMenu actions={actions} customButton={AddNewButton} />
      }
    />
  );
};

export default BulkPropertyActionMenu;
